
















import { Component, Vue, Prop } from 'vue-property-decorator';
import MoreIcon from '@/components/icons/MoreIcon.vue';

@Component({
  components: {
    MoreIcon
  }
})
export default class MenuButton extends Vue {
  private menuOpen:Boolean = false;
}
